export const issueStatus = ['created', 'resolved'];
export const mockGladosErrors_Creation = {
    "type": "test_creation_error",
    "id": "???",
    "message": "?????",
    "payload": [
        {
            "status": "created",
            "id": "00001a9d77dab5f2f3fc14efdec7ffff",
            "type": "Variable",
            "entityId": "00d47a9d77dab5f2f3fc14efdec79fcb",
            "description": "[HV] angina"
        },
        {
            "status": "created",
            "id": "000025b1414a2be7a012ab2df575ffff",
            "type": "val",
            "entityId": "012a65b1414a2be7a012ab2df5758429",
            "description": "Value OCT, but bad entity name"
        }
    ]
};
export const mockGladosErrors_Resolving = {
    "type": "test_resolving_error",
    "id": "???",
    "message": "?????",
    "payload": [
        {
            "status": "resolved",
            "id": "00001a9d77dab5f2f3fc14efdec7ffff",
            "type": "Variable",
            "entityId": "00d47a9d77dab5f2f3fc14efdec79fcb",
            "description": "[HV] angina"
        },
        {
            "status": "resolved",
            "id": "000025b1414a2be7a012ab2df575ffff",
            "type": "val",
            "entityId": "012a65b1414a2be7a012ab2df5758429",
            "description": "Value OCT, but bad entity name"
        }
    ]
};
//# sourceMappingURL=consts.js.map